<!--
 * Path: src/core/components/common/baseTab.vue
 * Task: Standardized individual tab element matching the application's clean design. Text aligns left for vertical support.
-->
<template>
  <v-tab
    :value="value"
    :disabled="disabled"
    class="base-tab text-none font-weight-medium justify-start"
  >
    <v-icon v-if="icon" start>{{ icon }}</v-icon>
    <slot>{{ title }}</slot>
  </v-tab>
</template>

<script setup lang="ts">
/**
 * Path: src/core/components/common/baseTab.vue
 * Task: Binds standard v-tab properties dynamically.
 */
interface Props {
  value: any;
  title?: string;
  icon?: string;
  disabled?: boolean;
}

withDefaults(defineProps<Props>(), {
  disabled: false
});
</script>
